"use strict";

import { Model } from "Model";
import { Objects } from "Constants/objects";
export var FormDecorationElementsModel = Model.extend({
  initialize: function initialize() {
    this.object = Objects.SysFormDecorationElements;
  }
});